<template>
    <div>
        <MainPage @clickBack="clickBack()" customClass="pb-0 max-w-6xl min-h-screen lg:relative">
            <div v-if="isLoaded" class="lg:pb-4">
                <div class="w-full px-4 py-4 lg:px-0 lg:pt-0 wrapper-search max-w-6xl">
                    <div class="flex shadow-text bg-white p-2 rounded-5">
                        <img class="mr-2" src="@/assets/icon/icon-search-gray.svg"/>
                        <input class="w-full placeholder-a-brown-9f8273 text-a-brown-502314 text-14 lg:text-16"
                            id="search-input"
                            v-model="search"
                            type="text"
                            placeholder="Search your location">
                    </div>
                </div>
                <div class="lg:grid lg:grid-cols-3 lg:border lg:border-a-brown-d7c7b8 ">
                    <div class="lg:order-last lg:col-span-2 relative">
                        <div class="map map-area " id="map"></div>
                        <div class="info-address" v-if="branchActive">
                            <div class="wrapper-address p-3 border border-a-brown-d7c7b8 rounded-10 bg-white shadow-text">
                                <div class="relative border-b border-a-brown-d7c7b8">
                                    <div class="text-14 text-a-red-d62300 font-bold pb-2">{{getName(branchActive)}}</div>

                                    <div class="text-12 text-a-brown-9f8273 pb-3">
                                        <div>
                                            <template v-if="isPickupBranchOpen">
                                                {{lbl.deliverymethod.self_pickup}}
                                            </template>
                                            <template v-else>
                                                {{ lbl.deliverymethod.no_self_pickup }}
                                            </template>
                                        </div>
                                        <div >
                                            <template v-if="isPickupBranchOpen">
                                                <div v-html="getWorkDay(branchActive)"></div>
                                            </template>
                                        </div>
                                        <div>
                                            <template v-if="isBranchOpen">
                                                {{lbl.deliverymethod.delivery}}
                                            </template>
                                            <template v-else>
                                                {{ lbl.deliverymethod.no_delivery }}
                                            </template>
                                        </div>
                                        <div >
                                            <template v-if="isBranchOpen">
                                                <div v-html="getWorkDay(branchActive)"></div>
                                            </template>
                                        </div>
                                    </div>

                                    <img class="absolute top-0 right-0 h-4 " @click="hideInfo()" src="@/assets/icon/ic-close-brown.svg" />
                                </div>
                                <div class="flex pt-3">
                                    <div v-for="(service, index) in branchActive.services"
                                        :key="index">
                                        <img class="h-6" :src="getPartService(service)" />
                                    </div>
                                    <div @click="clickDetail()" class="text-14 text-a-red-d62300 mr-0 ml-auto my-auto underline">Details</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="px-4 branch-list">
                        <div class="grid grid-cols-3 border-b border-a-brown-d7c7b8 text-14 text-center cursor-pointer">
                            <div class="py-2"
                                :class="{'border-b-4 border-a-red-d62300 text-a-red-d62300': tabActive == 'Bangkok'}"
                                @click="clickTab('Bangkok')">{{lbl.store.bangkok}}</div>
                            <div class="py-2"
                                :class="{'border-b-4 border-a-red-d62300 text-a-red-d62300': tabActive == 'Provincial'}"
                                @click="clickTab('Provincial')">{{lbl.store.provincial}}</div>
                            <div class="py-2"
                                :class="{'border-b-4 border-a-red-d62300 text-a-red-d62300': tabActive == 'Airport'}"
                                @click="clickTab('Airport')">{{lbl.store.airport}}</div>
                        </div>
                        <div class="text-14 text-a-brown-502314 pt-4">{{lbl.store.nearby}}</div>
                        <BranchItem
                            v-for="(branch, k) in filteredBranchList"
                            :branch="branch"
                            :key="k"
                            @selectBranch="selectBranch($event)"
                        ></BranchItem>
                    </div>
                </div>
                <div class="control-map">
                    <img class="btn-current-map" src="../../../assets/map/current-location.svg" @click="clickCurrentLocation()">
                </div>
            </div>
        </MainPage>
    </div>
</template>

<script>
//lib
import { Loader } from '@googlemaps/js-api-loader'; //https://www.npmjs.com/package/@googlemaps/js-api-loader
//components
import MainPage from "@/components/Layout/Page/MainPage.vue";
import BranchItem from "@/module/DeliveryMethod/component/BranchItem.vue";
//helper
import Location from "@/helper/LocationHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
import Util from "@/helper/Utility.js";
//service
import { BranchConfigBuilder } from '@/module/DeliveryMethod/model/BranchConfigModel.js';
import BKDeliveryMethod from '@/module/DeliveryMethod/service/BKDeliveryMethod';
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";
// svg icon
import iconPinMap from "@/assets/icon/ic-pin-bk.svg";
import iconPinCurrent from "@/assets/icon/ic-pin-current-bk.svg";

export default {
    name: "Store",
    mixins: [ModalMixin,LocaleMixin],
    components: {
        MainPage,
        BranchItem
    },
    data: function() {
        return {
            currentLocation: {
                lat: 13.7451765,
                lng: 100.5081332
            },
            isLoaded: false,
            branchList: [],

            search: "",
            map: null,
            googleMaps: null,
            geocoder: null,
            markers: [],
            tabActive: "Bangkok",
            branchActive: null,
        };
    },
    computed: {
        filteredBranchList() {
            return this.branchList.filter(branch => {
                if (this.localeCode == 1033) {
                    return branch.region == this.tabActive && branch.nameEN.toLowerCase().includes(this.search.toLowerCase());
                } else {
                    return branch.region == this.tabActive && branch.name.toLowerCase().includes(this.search.toLowerCase());
                }
            })
        },
        isBranchOpen() {
            return this.branchActive?.isBranchOpen
        },
        isPickupBranchOpen() {
            return this.branchActive?.isPickupBranchOpen
        }
    },
    created: async function() {
        await this.initialBranch();
        await this.getCurrentLocation();
    },
    mounted: function() {
        this.modal.loadingModal.show();
    },
    methods: {
        getCurrentLocation: function() {
            return new Promise((resolve) => {
                Location.getCurrentLocation().then((location) => {
                    this.currentLocation = location;
                    this.initialBranch();
                    resolve();
                }).catch((err) => {
                    console.log(err);
                    resolve();
                });
            });
        },
        clickTab: async function(tabActive) {
            this.tabActive = tabActive;

            await this.initialMaps();
            this.pinBranch();

            let latLng = null
            if (this.tabActive == "Bangkok")
                latLng = new this.googleMaps.maps.LatLng(13.7451765, 100.5081332);
            else if (this.tabActive == "Provincial")
                latLng = new this.googleMaps.maps.LatLng(7.89167, 98.2996125);
            else
                latLng = new this.googleMaps.maps.LatLng(13.7451765, 100.5081332);

            this.map.setCenter(latLng);
        },
        initialBranch: async function () {
            this.branchConfig = new BranchConfigBuilder()
                .setCenter(this.currentLocation.lat,this.currentLocation.lng)
                .create();

            if (await this.apiGetBranch()) {
                this.isLoaded = true;
                await this.initialMaps();
                this.pinBranch();
                this.pinCurrent();
            }
        },
        initialMaps: function () {
            return new Promise((resolve) => {
                var key = ConfigManager.getGoogleMapsKey()
                const loader = new Loader({
                    apiKey: key,
                    version: "weekly",
                    libraries: ["places"]
                });
                loader.load().then((google) => {
                    this.map = new google.maps.Map(document.getElementById("map"), {
                        center: {
                            lat: this.branchList[0].location.latitude,
                            lng: this.branchList[0].location.longitude,
                        },
                        zoom: 15,
                        mapTypeId: "roadmap",
                        disableDefaultUI: true,
                        fullscreenControl: false,
                        clickableIcons: false,
                        clickableLabels: false,
                        zoomControl: true,
                    });
                    this.map.addListener('click', (e) => {
                        this.map.setCenter(e.latLng);
                    });
                    this.map.addListener('bounds_changed', () => {
                        this.branchActive = null;
                    });


                    this.googleMaps = google;

                    resolve(true);
                })
                .catch(e => {
                    console.log(e);
                    // do something
                });
            });
        },
        pinCurrent: function() {
            console.log("pinCurrent");
            this.markers = [];
            this.markers.push(
                new this.googleMaps.maps.Marker({
                    position: this.currentLocation,
                    icon: iconPinCurrent,
                    map: this.map,
                    animation: this.googleMaps.maps.Animation.DROP,
                })
            );
        },
        pinBranch: function() {
            this.markers = [];
            for (let branchItem of this.filteredBranchList) {
                if (branchItem.location) {
                    this.pinMarker(branchItem)
                }
            }
        },
        pinMarker: function(branchItem) {
            let positionBranch = {
                lat: branchItem.location.latitude,
                lng: branchItem.location.longitude,
            }
            let marker = new this.googleMaps.maps.Marker({
                    position: positionBranch,
                    icon: iconPinMap,
                    map: this.map,
                    animation: this.googleMaps.maps.Animation.DROP,
                });
            marker.addListener('click', () => {
                this.showInfo(branchItem);
            });
            this.markers.push(marker);
        },
        showInfo: function(branchItem) {
            let latLng = new this.googleMaps.maps.LatLng(branchItem.location.latitude + 0.03, branchItem.location.longitude);
            this.map.setCenter(latLng);
            this.map.setZoom(12);
            setTimeout(()=>{
                this.branchActive = branchItem;
                Util.scrollTop();
            },500);
        },
        hideInfo: function() {
            this.branchActive = null;
        },
        clickCurrentLocation: function () {
            this.map.setCenter(this.currentLocation);
        },
        selectBranch: function(objBranch) {
            this.showInfo(objBranch);
        },
        clickDetail: function() {
            this.modal.storeDetailModal
                                    .clearModal()
                                    .setBranch(this.branchActive)
                                    .setCurrentLocation(this.currentLocation)
                                    .show();
        },
        apiGetBranch: async function() {
            return new Promise((resolve) => {
                let params = this.branchConfig.getParams()
                BKDeliveryMethod.apiGetBranch(params).subscribe({
                    next: (data) => {
                        console.log(data);
                        this.branchList = data;
                        this.modal.loadingModal.hide();
                        resolve(true);
                    },
                    error: (err) => {
                        this.modal.loadingModal.hide();
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        clickBack: function() {
            this.$router.back();
        },
        getName: function(branch) {
            if (this.localeCode == 1033) {
                return branch.nameEN;
            } else {
                return branch.name;
            }
        },
        getWorkDay: function(branch) {
            if (this.localeCode == 1033) {
                return branch.workingDayEn
            } else {
                return branch.workingDay
            }
        },
        getPartService: function(service) {
            let url = ConfigManager.getBlobUrl() + "/agencylocationservices/" + ConfigManager.getAppId() + "/_" + service.id;
            return url;
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .map-area {
        height: calc(100vh / 2);

        @include min-desktop {
            height: calc(100vh - 240px);
        }

    }
    .branch-list {
        @include min-desktop {
            height: calc(100vh - 240px);
            overflow-y: scroll;
        }
    }

    .info-address {
        position: absolute;
        width: 100%;
        display: flex;
        bottom: calc(50% - 10px);

        .wrapper-address {
            width: 320px;
            margin: auto;
        }
    }

    .control-map {
        position: absolute;
        right: 12px;
        bottom: calc(50% - 15px);
        @include min-desktop {
            bottom: 140px;
        }
        .btn-current-map {
            width: 34px;
            right: 12px;
        }
    }
</style>
